import auth, { IOAuthParams } from '../services/auth';
import { OAUTH_QS_KEY } from '../constants/storage';
import location from '../services/location';
import queryString, { IParams } from '../services/queryString';
import redirect from '../actions/redirect';
import routes from '../constants/routes';
import routing from '../services/routing';
import storage from '../services/storage';
import { LOGIN_V2 } from '../constants/auth';

export const socialToken = async () => {
    const qs: { code?: string } = queryString.parse(routing.location.search);
    const idpRedirectUrl = `${location.protocol}//${location.host}${routes.IDP_TOKEN}`;
    const storedParams: IParams = storage.loadState(OAUTH_QS_KEY);
    if (!qs.code) {
        throw new Error('No code in query string');
    }
    const res =
        LOGIN_V2 || storedParams.LOGIN_V2
            ? await auth.socialTokenV2({
                  code: qs.code,
                  queryParams: storedParams,
                  idpRedirectUrl: idpRedirectUrl,
              })
            : await auth.socialToken({
                  ...storedParams,
                  code: qs.code,
                  grant_type: 'authorization_code',
                  original_redirect_uri: storedParams.redirect_uri,
                  redirect_uri: idpRedirectUrl,
              });
    redirect(res.data);
};

export default socialToken;
